// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"049c0400","226":"74f86a72","397":"7f44335e","453":"e4cb5df6"}[chunkId] + ".chunk.js";
};